import { toast, ToastOptions as ReactToastifyOptions } from 'react-toastify';
import type { PromiseMessages, ToastOptions } from '../types';

// Toast configuration
const defaultOptions: ReactToastifyOptions = {
  position: 'top-right',
  autoClose: 4000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

// Success toast
export const showSuccess = (message: string, options: ToastOptions = {}): void => {
  toast.success(message, { ...defaultOptions, ...options });
};

// Error toast
export const showError = (message: string, options: ToastOptions = {}): void => {
  toast.error(message, { ...defaultOptions, autoClose: 5000, ...options });
};

// Warning toast
export const showWarning = (message: string, options: ToastOptions = {}): void => {
  toast.warning(message, { ...defaultOptions, ...options });
};

// Info toast
export const showInfo = (message: string, options: ToastOptions = {}): void => {
  toast.info(message, { ...defaultOptions, ...options });
};

// Promise toast for async operations
export const showPromise = <T>(
  promise: Promise<T>,
  messages: PromiseMessages,
  options: ToastOptions = {}
): Promise<T> => {
  toast.promise(
    promise,
    {
      pending: messages.pending || 'Зареждане...',
      success: messages.success || 'Успешно!',
      error: messages.error || 'Възникна грешка',
    },
    { ...defaultOptions, ...options }
  );
  return promise;
};

const notify = {
  success: showSuccess,
  error: showError,
  warning: showWarning,
  info: showInfo,
  promise: showPromise,
};

export default notify;
